/**
 * Event creation types — the wizard's config shape + the structural blank
 * default.
 *
 * Docket 2026-07-26 §1.2.3: the vertical event-type entries that lived here
 * (banking's "Quarterly Financial Wellness Series", retail's "Product
 * Education & Tasting / Try-On", "VIP / Loyalty Member Experiences",
 * "Seasonal & Milestone Shopping", the higher-ed set, …) are DELETED from
 * source — they were one vertical's catalog offered to every tenant. Event-
 * type templates are tenant catalog data and arrive through the typed
 * @v0y4ge/api-client (the event-templates op the Type step already renders
 * and seeds from via `seedFromTemplate`), backed by @v0y4ge/api-mocks;
 * REQ-091 asks the served templates to carry the deleted entries' defaults
 * (method / visibility / waitlist / starter tickets). Only the structural
 * `blank` default remains in source; the type picker renders served templates
 * and falls back to Build-from-scratch while they load.
 */

import { T } from "@v0y4ge/jrni-ui";

export interface TicketSeed {
  id: string; name: string; desc?: string;
  price?: number; capacity?: number | null; sold?: number;
  color?: string; kind?: "free" | "paid" | "code";
  refundable?: boolean; visibility?: "public" | "hidden";
  perOrderLimit?: number; salesStart?: string; salesEnd?: string;
  accessCode?: string;
}

export interface CreationConfig {
  id: string; label: string;
  pillText?: string; pillTone?: string;
  heroFrom?: string; heroTo?: string; heroLetters?: string;
  title?: string; description?: string;
  method: { inPerson: boolean; virtual: boolean };
  visibility: string;
  tags?: string[];
  start?: string; end?: string; repeatIndex?: number;
  capacity?: number | null; waitlist?: number | null;
  tickets?: TicketSeed[];
  questions?: unknown[];
  publishRows?: Record<string, [string, string][]>;
  publishWarnings?: string[];
  slug?: string;
}

export const CREATION_CONFIGS: Record<string, CreationConfig> = {
  blank: {
    id: "blank", label: "Build from scratch",
    pillText: "Blank", pillTone: "neutral",
    heroFrom: T.n2, heroTo: T.n1, heroLetters: "EV",
    title: "", description: "",
    method: { inPerson: true, virtual: false },
    visibility: "Public · Anyone with link",
    tags: [], repeatIndex: 0, capacity: null, waitlist: null, tickets: [], questions: [],
  },
};

// Verbatim from the prototype — the labels that appear in the Schedule step
// repeat picker. Index = `cfg.repeatIndex`.
export const REPEAT_LABELS_ALL: string[] = [
  "Doesn't repeat",
  "Weekly on the same day",
  "Monthly on this date",
  "Monthly on this weekday",
  "Quarterly on this date",
  "Quarterly on this weekday",
  "Custom…",
];
